import { currencies } from 'client-site-chrome-ui/content/currencies';

export const getCurrency = (code: string) =>
  currencies.find((currency) => currency.code === code) ?? null;
